import React from 'react';
import { useT } from '@repo/common';
import HeaderText from '../../Common/HeaderText';
import PaymentsListHeader from '../PaymentsListHeader';
import PaymentsList from './PaymentsList';

const PendingPayments = () => {
  const t = useT();
  return (
    <div className='flex flex-col w-full items-start'>
      <HeaderText label={t('Pending Payments', '대기 중인 결제')} />
      <PaymentsListHeader />
      <PaymentsList />
    </div>
  );
};

export default PendingPayments;
